<template>
  <div class="c-calendar-components">
    <Loader v-if="isLoading"/>
    <FullCalendar ref="fullCalendar"
        :options="calendarOptions" 
        />
  </div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import moment from "moment";
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import axios from "axios";
import Loader from "./Loader";

export default {
  name: "Calendar",
  props: ["firstInstance", "lastInstance"],
  components: {
    FullCalendar,
    Loader,
  },
  data() {
    return {
      calendarOptions: {
        firstDay: 0,
        headerToolbar: {
          start: 'prev,next,title',
          end: 'grid_view,calendar_view'
        },
        dayMaxEventRows: true,
        views: {
          dayGridMonth: {
            dayMaxEventRows: 6
          },
          listMonth: {
            dayMaxEventRows: 6
          },
        },
        footerToolbar: false,
        height: "auto",
        plugins: [dayGridPlugin, listPlugin],
        initialView: "dayGridMonth",
        events: [],
        displayEventTime: false,
        eventContent: this.eventContent,
        listDaySideFormat: false,
        fixedWeekCount: false,
        timeZone: "UTC",

        customButtons: {
            grid_view: {
                text: 'Grid',
                click: function() {
                    window.location.href = '/events';
                }
            },
            calendar_view: {
                text: 'Calendar',
                click: function() {
                    // on correct page anyway.
                }
            }
        },
      },
      isLoading: true,
      allInstances: {},
      calendarApi: null,
      currentView: '',
    };
  },
  mounted() {
    this.addEventListeners();
    this.calendarApi = this.$refs.fullCalendar.getApi();
    this.urlParamJumpMonth();
    this.fetchEvents();
    this.setView();
    window.onresize = () => {
        this.setView();
    }

  },
  methods: {
    setView() {
      const view = window.innerWidth < 1000 ? 'listMonth' : 'dayGridMonth';
      this.currentView = view;
      this.calendarApi.changeView(view);
      this.fetchEvents();
    },
    addEventListeners() {
      this.nextAndPreviousButtonAdditionalEvents();
    },
    eventContent(arg) {
      return {
        html: arg.event.title,
      };
    },
    fetchEvents() {
        let currentDate = moment.utc(this.calendarApi.currentData.currentDate);
        let currentMonth = currentDate.format("YYYY-MM");
        if (this.allInstances.hasOwnProperty(currentMonth)) {
            this.calendarOptions.events = this.allInstances[currentMonth];
        } else {
            this.isLoading = true;
            // Otherwise, fetch the instances
            let params = this.setupQueryParams();

            axios.get(window.wpAjax.url, {
                params: params,
            }).then((response) => {
                const instances = response.data;
                // Push our instances to the allInstances property, so we can use those next 
                // time rather than make another ajax call
                this.allInstances[currentMonth] = instances;
                // Assign the instances to our property as that is passed to the calendar
                this.calendarOptions.events = instances;
                this.isLoading = false;
            }).catch((error) => {
                this.isLoading = false;
                console.log(error);
            });
        }
    },
    gotoMonth(selectedMonth) {
      let month = moment(new Date(selectedMonth)).utc().startOf("month");
      this.calendarApi.gotoDate(month.format("YYYY-MM-DD"));
    },
    nextAndPreviousButtonAdditionalEvents() {
      // previous button
      document.querySelector(".fc-prev-button").addEventListener('click', (e) => {
        this.fetchEvents();
      });

      // next button
      document.querySelector(".fc-next-button").addEventListener('click', (e) => {
        this.fetchEvents();
      });
    },
    setupQueryParams() {
      return {
        action: "basethemeCalendarRequest",
        viewType: this.currentView,
        start: moment.utc(this.calendarApi.currentData.currentDate).format(),
        end: moment.utc(this.calendarApi.currentData.currentDate).endOf("month").format(),
      };
    },
    urlParamJumpMonth() {
      const urlParams = new URLSearchParams(window.location.search);

      if (urlParams.has("month")) {
        const selectedMonth = urlParams.get("month");
        this.gotoMonth(selectedMonth);
      }
    },
    on(selector, eventType, childSelector, eventHandler) {
      const elements = document.querySelectorAll(selector);
      for (let element of elements) {
        element.addEventListener(eventType, (eventOnElement) => {
          if (eventOnElement.target.matches(childSelector)) {
            eventHandler(eventOnElement);
          }
        });
      }
    },
  },
};
</script>

